function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { initMenu, changeActiveMenuFromLocation } from '../../redux/appMenu/actions';

const MenuItemWithChildren = ({
  item,
  linkClassNames,
  subMenuClassNames,
  activatedMenuItemIds
}) => {
  return /*#__PURE__*/React.createElement("li", {
    className: classNames('side-nav-item', {
      'active mm-active': activatedMenuItemIds.indexOf(item.id) >= 0
    })
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: classNames('has-arrow', 'side-sub-nav-link', linkClassNames),
    "aria-expanded": activatedMenuItemIds.indexOf(item.id) >= 0
  }, item.icon && /*#__PURE__*/React.createElement("i", {
    className: item.icon
  }), item.badge && /*#__PURE__*/React.createElement("span", {
    className: `badge badge-${item.badge.variant} float-right`
  }, item.badge.text), /*#__PURE__*/React.createElement("span", null, " ", item.name, " ")), /*#__PURE__*/React.createElement("ul", {
    className: classNames(subMenuClassNames, 'mm-collapse', {
      'mm-collapsed mm-show': activatedMenuItemIds.indexOf(item.id) >= 0
    }),
    "aria-expanded": activatedMenuItemIds.indexOf(item.id) >= 0
  }, item.children.map((child, i) => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, child.children ? /*#__PURE__*/React.createElement(MenuItemWithChildren, {
      item: child,
      linkClassNames: "",
      activatedMenuItemIds: activatedMenuItemIds,
      subMenuClassNames: "side-nav-third-level"
    }) : /*#__PURE__*/React.createElement(MenuItem, {
      item: child,
      className: classNames({
        active: activatedMenuItemIds.indexOf(child.id) >= 0
      }),
      linkClassName: ""
    }));
  })));
};

const MenuItem = ({
  item,
  className,
  linkClassName
}) => {
  return /*#__PURE__*/React.createElement("li", {
    className: classNames('side-nav-item', className)
  }, /*#__PURE__*/React.createElement(MenuItemLink, {
    item: item,
    className: linkClassName
  }));
};

const MenuItemLink = ({
  item,
  className
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    to: item.path,
    className: classNames('side-nav-link-ref', 'side-sub-nav-link', className)
  }, item.icon && /*#__PURE__*/React.createElement("i", {
    className: item.icon
  }), item.badge && /*#__PURE__*/React.createElement("span", {
    className: `badge badge-${item.badge.variant} float-right`
  }, item.badge.text), /*#__PURE__*/React.createElement("span", null, " ", item.name, " "));
};
/**
 * Renders the application menu
 */


class AppMenu extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "componentDidMount", () => {
      if (!this.props.menu.menuItems) this.props.initMenu();else this.initMenu();
      this.props.history.listen((location, action) => {
        this.props.changeActiveMenuFromLocation();
      });
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (!prevProps.menu.menuItems || prevProps.menu.menuItems && prevProps.menu.menuItems !== this.props.menu.menuItems) {
        if (document.querySelector('#menu-bar')) {
          this.initMenu();
        } else {
          console.log('init menu failed');
        }
      }
    });
  }

  initMenu() {
    if (this.props.mode === 'horizontal') {
      const menuRef = new MetisMenu('#menu-bar').on('shown.metisMenu', function (event) {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement);
            window.removeEventListener('click', menuClick);
          }
        });
      });
    } else {
      new MetisMenu('#menu-bar');
    }
  }

  render() {
    const isHorizontal = this.props.mode === 'horizontal';
    const activatedKeys = isHorizontal ? [] : this.props.menu ? this.props.menu.activatedMenuItemIds : [] || [];
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classNames({
        'topbar-nav': isHorizontal
      })
    }, this.props.menu && this.props.menu.menuItems && /*#__PURE__*/React.createElement("ul", {
      className: "metismenu side-nav",
      id: "menu-bar"
    }, this.props.menu.menuItems.map((item, i) => {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: item.id
      }, item.header && !isHorizontal && /*#__PURE__*/React.createElement("li", {
        className: "side-nav-title side-nav-item",
        key: i + '-el'
      }, item.header), item.children ? /*#__PURE__*/React.createElement(MenuItemWithChildren, {
        item: item,
        subMenuClassNames: "side-nav-second-level",
        activatedMenuItemIds: activatedKeys || [],
        linkClassNames: "side-nav-link"
      }) : /*#__PURE__*/React.createElement(MenuItem, {
        item: item,
        className: classNames({
          active: !!activatedKeys && activatedKeys.indexOf(item.id) >= 0
        }),
        linkClassName: "side-nav-link"
      }));
    }))));
  }

}

_defineProperty(AppMenu, "defaultProps", {
  mode: 'vertical'
});

const mapStateToProps = state => {
  return {
    menu: state.appMenu
  };
};

export default withRouter(connect(mapStateToProps, {
  initMenu,
  changeActiveMenuFromLocation
})(AppMenu));